
import macroCarreteras from './macroCarreteras'

export default () => {
  return Promise.all([
    ...macroCarreteras(),
  ].map(p => p))
}


// WEBPACK FOOTER //
// ./src/services/prefetch/index.js